import { Injectable, TemplateRef } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ModalsService {
    default = { type: undefined, data: {} }
    modal$ = new BehaviorSubject<{
        type: string;
        data: Record<any, any>;
    }>(this.default);

    constructor() {}

    closeModal() {
            this.modal$.next(this.default)
    }
}
